import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  Router,
  withComponentInputBinding,
} from '@angular/router';
import { localeInterceptor, provideI18N } from '@front/shared/util-i18n';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { withInMemoryScrolling } from '@angular/router';
import { authInterceptor } from '@front/frontend/data-access-auth/interceptors/auth.interceptor';
import { networkErrorInterceptor } from '@front/frontend/data-access-auth/interceptors/network-error.interceptor';
import { AuthStore } from '@front/frontend/data-access-auth/stores/auth.store';
import { provideEncryptedStorage } from '@irontec/ngx-encrypted-storage';
import { ENVIRONMENT } from '@front/shared/util-environment';
import * as Sentry from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideI18N(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor, 
        localeInterceptor,
        networkErrorInterceptor  // 👈 Añadido aquí
      ])
    ),
    AuthStore,
    provideEncryptedStorage('frontend'),
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        // Required for TraceService initialization
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};